<template>
  <a-card :bordered="false">
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :label-col="labelCol1" :wrapper-col="wrapperCol1" :rules="validatorRules"
        slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="this.language['cs.floorcode']" prop="floorcode">
              <a-input v-model="model.floorcode" :placeholder="this.language['cs.floorcode']" :maxLength="50"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="this.language['cs.floorname']" prop="floorname">
              <a-input v-model="model.floorname" :placeholder="this.language['cs.floorname']" :maxLength="60"></a-input>
            </a-form-model-item>
                <!-- 上傳附件圖片 -->
            <a-form-model-item :label="this.language['common.uploadPicture']" :labelCol="labelCol1" :wrapperCol="wrapperCol1"
              prop="files">
              <j-image-upload class="avatar-uploader" text="上传" :upload-source="uploadSource" v-model="model.files"
                :isMultiple="true" :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>


  <!-- 子表单区域 -->
  <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="區域設置信息" :key="refKeys[0]" :forceRender="true">
          <j-editable-table 
          :ref="refKeys[0]" 
          :loading="areas.loading" 
          :columns="columns"
          :dataSource="areas.dataSource" 
          :maxHeight="400" 
          :maxNumber="100" 
          :disabled="formDisabled"
          :rowNumber="true" 
          :rowSelection="true" 
          @valueChange="valueChange"
          :actionButton="true" />
        </a-tab-pane>
      </a-tabs>
</a-card>
</template>
  
  
<script>

import { validateDuplicateValue,hasValue} from '@/utils/util'
import { httpAction, getAction } from '@/api/manageChooseSeat'
import moment from 'moment'
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormModelAndTables } from '@/utils/JEditableTableUtil'
import { JEditableTableModelMixin } from '@/views/chooseSeat/mixins/JEditableTableModelMixin'


export default {
  name: 'FloorForm',
  mixins: [JEditableTableModelMixin],
  components: {},
  props: {
    //表单禁用
    parent:{
      type:Object,
      default:{}
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {},
      uploadSource: "chooseseat",


      addDefaultRowNum: 1,
      refKeys: ['areaList',],
      tableKeys: ['areaList',],
      activeKey: 'areaList',

      areas: {
        loading: false,
        dataSource: [],
      },
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
      confirmLoading: false,
      url: {
        add: "/VenueFLoor/addData",
        edit: "/VenueFLoor/editData"
      },
      selectActivityList: [],
      selectPgList: [],
      selectVenueList: []
    }
  },
  props: {
    //调用父页面
    from: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },

    validatorRules() {
      if (this.language) {
        return {
          floorname: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.floorname'] },
          ],
          floorcode: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.floorcode'] },
          ]

        }
      }
    },
    columns() {
        if (this.language) {
          return[
          // {
          //     title: this.language['sysvenueid'],
          //     key: 'sysvenueid',
          //     type: FormTypes.hidden,
          //     width:"200px",
          //     placeholder: this.language['fd.input']+'${title}',
          //     defaultValue:'',
          //   },
          //   {
          //     title: this.language['sysfloorid'],
          //     key: 'sysfloorid',
          //     type: FormTypes.hidden,
          //     width:"200px",
          //     placeholder: this.language['fd.input']+'${title}',
          //     defaultValue:'',
          //   },
            {
              title: this.language['sysareaid'],
              key: 'sysareaid',
              type: FormTypes.hidden,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              defaultValue:'',
            },
            {
              title: this.language['cs.areacode'],
              key: 'areacode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: this.language['cs.areaname'],
              key: 'areaname',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: this.language['cs.maxrowqty'],
              key: 'maxRowQty',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: this.language['cs.maxcolqty'],
              key: 'maxColQty',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
            title: this.language['cs.uploadareaimage'] ,
            key: 'files',
            type: FormTypes.file,
            token:true,
            responseName:"message",
            width:"200px",
            placeholder: this.language['common.pleaseInput']+this.language['common.file'],
            defaultValue:'',
            validateRules: [{ required: false, message: this.language['fd.input'] + '${title}' }],
          },
            {
              title: this.language['cs.seat.seattotalqty'],
              key: 'seatcount',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              disabled:true,
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
          
          ]

          }
        }

  },
  created() {
    //备份model原始值
    // this.modelDefault = JSON.parse(JSON.stringify(this.model));
    // this.loadSelectData();
    if(this.from!="VenueList")
    {
      this.url.add="/ActivityFLoor/addData";
      this.url.edit= "/ActivityFLoor/editData"
    }
  },
  mounted() {
  },
  watch: {

  },
  methods: {

    add() {
      // this.edit(this.modelDefault);
      this.visible = true;
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.areas.dataSource=record.children;
      this.visible = true;
    },

    submitForm() {



      this.model.id=this.model.sysfloorid;

      this.handleOk();
      // const that = this;
      // // 触发表单验证
      // this.$refs.form.validate(valid => {

      //   if (valid) {
      //     that.confirmLoading = true;
      //     let httpurl = '';
      //     let method = '';
      //     if (!that.model.sysfloorid) {
      //       httpurl += that.url.add;
      //       method = 'post';
      //     } else {
      //       httpurl += that.url.edit;
      //       method = 'put';
      //     }
      //     that.model.children=that.areas.dataSource;
      //     httpAction(httpurl, that.model, method).then((res) => {
      //       if (res.success) {
      //         that.$message.success(res.message);
      //         that.$emit('refreshTree');
      //         that.$emit('ok');
      //       } else {
      //         that.$message.warning(res.message);
      //       }
      //     }).finally(() => {
      //       that.confirmLoading = false;
      //     })
      //   }

      // })
    },

    valueChange(e) {
      let { type, row, column, value, target } = e
      var tab = this.$refs[this.refKeys[0]]
     
      // 重新计算值
      if (column.key === 'areacount'||column.key === 'maxRowQty'||column.key === 'maxColQty') {
        this.computeValue(row, tab)
      }
      // this.refreshValidate()
    },
    // 重新计算值
    computeValue(row, tab) {
      let seatcount = 0
      let maxlineofarea = row.maxRowQty
      let maxcolumnofarea= row.maxColQty

      if (hasValue(maxlineofarea)&&hasValue(maxcolumnofarea)) {
        // 座位数=区域数*行数*列数
        seatcount = maxlineofarea*maxcolumnofarea
        
      }
  
      tab.setValues([{ rowKey: row.id, values: { seatcount } }])
      this.refreshValidate()
    },
    refreshValidate() {
      var tab = this.$refs[this.activeKey]
      if (tab) {
        tab.getValuesSync(true)
      }
    },
    close() {
      this.$emit('close');
      this.$refs.form.clearValidate()
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        children: allValues.tablesValue[0].values
      }
    },


  }
}


</script>